// import { apihost } from '@/api/urls';
import axios, { AxiosResponse } from 'axios';
import AuthService from '@/services/AuthService';
import qs from 'qs';

const auth = new AuthService();

axios.interceptors.request.use(
  (config) => {
    return auth.getUser().then((user) => {
      if (user) {
        config.headers.Authorization = `Bearer ${user.access_token}`;
      }

      return config;
    });
  },

  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    if (error.response.status === 401) {
      auth.login();
    }

    return Promise.reject(error);
  },
);

const get = (url: string, apihost: string) => {
  return axios.get(`${apihost}${url}`);
};

const getParams = (url: string, apihost: string, params: any) => {
  return axios.get(`${apihost}${url}`, {
    params,
    paramsSerializer: (p: any) => qs.stringify(p, { arrayFormat: 'repeat' }),
  });
};

const put = (url: string, apihost: string, json: any) => {
  return axios.put(`${apihost}${url}`, json);
};

const del = (url: string, apihost: string) => {
  return axios.delete(`${apihost}${url}`);
};

const post = (url: string, apihost: string, json: any) => {
  return axios.post(`${apihost}${url}`, json);
};
const getFile = (url: string, apihost: string) => {
  const options = {
    responseType: 'blob',
    timeout: 5000 * 60,
  };

  return axios.get(`${apihost}${url}`, options);
};

export const apiCaller = {
  get,
  put,
  post,
  del,
  getFile,
  getParams,
};
